import React from "react";

const DEFAULT_ICON_SIZE = 18;

const ButtonTextIcon = ({ icon, title, className = "", ...rest }) => {
	const sizedIcon = React.isValidElement(icon)
		? React.cloneElement(icon, {
			  size: DEFAULT_ICON_SIZE,
			  style: { verticalAlign: "middle", ...(icon.props.style || {}) },
		  })
		: icon;

	const cls = `btn-text-icon ${className}`.trim();

	return (
		<button className={cls} {...rest}>
			<span>
				{sizedIcon}
				<span>{title}</span>
			</span>
		</button>
	);
};

export default ButtonTextIcon;
